// extracted by mini-css-extract-plugin
export default {"gridClass":"style-module--gridClass--KQczh"};